import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { saveUserAppData } from '../../Api/userApi';
import { Input, Form, Divider, Typography, Modal } from 'antd';
import Button from '@mui/material/Button';
import {LibraryAddRounded} from "@mui/icons-material";


const APP_TYPES = ['screener', 'blacklist'];

const AppDataForm = ({ initialData, appType, initialTitle = '', appId = null,
                       open=false, onClose}) => {
  const [title, setTitle] = useState(initialTitle);
  const [data, setData] = useState(initialData);
  const dispatch = useDispatch();
  if (!APP_TYPES.includes(appType)) {
    throw new Error(`Invalid app type: ${appType}`);
  }
  useEffect(() => {
    // Update local state if initialData changes
    setData(initialData);
    setTitle(initialTitle);
  }, [initialData, initialTitle]);

  const handleSubmit = () => {
    const appData = {
      appType: appType, // This should be dynamic based on actual app types in your system
      title,
      data: data,
      id: appId
    };
    dispatch(saveUserAppData(appData));
    onClose?.();
  };

  return (
      <Modal open={open}
             title={'Saving to your App Data'}
             onOk={handleSubmit}
             onCancel={onClose}
      >
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item label="Title" required tooltip="This is a required field">
            <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter title for the app data" />
          </Form.Item>
          <Form.Item>
            <Button startIcon={<LibraryAddRounded/>} variant={'contained'} color="primary" type="submit">
              {appId ? 'Update App Data' : 'Add to App Data'}
            </Button>
          </Form.Item>
          <div>
            <Divider style={{border: '1px dashed #ddd'}}/>
            <Typography.Title level={4}>Data Preview</Typography.Title>
            <Divider style={{border: '1px dashed #ddd'}}/>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </div>
        </Form>
      </Modal>
  );
};

export default AppDataForm;
